<template>
  <div>
    <v-row>
      <v-col cols="7">
        <table class="tutor-study-result-table" id="style-2">
          <thead>
            <tr>
              <th>Chặng</th>
              <th>Bài học hoàn thành</th>
              <th>Bài tập hoàn thành</th>
              <th>Số câu đúng/ Tổng số câu</th>
              <th>Điểm trung bình</th>
            </tr>
          </thead>
          <tbody v-if="selfStudy && selfStudy.length">
            <tr v-for="(item, index) in selfStudy" :key="index + 'selfStudyTest'">
                <td><strong>{{item.courseName}}</strong></td>
                <td>
                    <span v-if="item.totalLesson">{{item.totalLessonCompleted}}/{{item.totalLesson}}</span>
                    <span v-else>--</span>
                </td>
                <td>
                    <span v-if="item.totalHomework">{{item.totalHomeworkCompleted}}/{{item.totalHomework}}</span>
                    <span v-else>--</span>
                </td>
                <td>
                    <span v-if="item.totalQuestion">{{item.correctQuestion}}/{{item.totalQuestion}}</span>
                    <span v-else>--</span>
                </td>
                <td>
                    <div class="d-flex justify-center">
                        <span>{{(item.avgPoint || item.avgPoint == 0) ? item.avgPoint : '--'}}</span>
                        <up-down-scope
                            v-if="item.comparePoint && ['increase','decrease'].includes(item.comparePoint) && item.comparePointAveragePoint"
                            :value="item.comparePointAveragePoint"
                            :kind="item.comparePoint"
                            :percent="false"
                        ></up-down-scope>
                    </div>
                </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
                <td colspan="5">Không có dữ liệu</td>
            </tr>
          </tbody>
        </table>
      </v-col>
      <v-col cols="5">
        <table class="tutor-study-result-table" id="style-2">
          <thead>
            <tr>
              <th>Kỹ năng</th>
              <th>Số câu đúng/ Tổng số câu</th>
              <th>Điểm trung bình</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in skills" :key="index + 'skills'">
                <td><strong>{{nameSkills[`${item.skillName}`]}}</strong></td>
                <td>
                    <span v-if="item.totalQuestion">{{item.correctQuestion}}/{{item.totalQuestion}}</span>
                    <span v-else>--</span>
                </td>
                <td>
                    <div class="d-flex justify-center">
                        <span>{{(item.avgPoint || item.avgPoint == 0) ? item.avgPoint : '--'}}</span>
                        <up-down-scope
                            v-if="item.comparePoint && ['increase','decrease'].includes(item.comparePoint) && item.comparePointAveragePoint"
                            :value="item.comparePointAveragePoint"
                            :kind="item.comparePoint"
                            :percent="false"
                        ></up-down-scope>
                    </div>
                </td>
            </tr>
          </tbody>
        </table>
      </v-col>
    </v-row>
    <note-filter-for-date :dateTime="filterForm.dateTime" textCustom='Thông tin điểm tăng/ giảm của học sinh được so sánh giữa khoảng thời gian được lựa chọn với khoảng từ'></note-filter-for-date>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BlendedCareRepository from '@/services/BlendedCareRepository';
import UpDownScope from '../ModalScoreDetail/UpDownScope.vue';
import NoteFilterForDate from '../ModalScoreDetail/NoteFilterForDate.vue';

export default {
  name: 'SelfStudyTest',
  components: {
    UpDownScope,
    NoteFilterForDate,
  },
  data() {
    return {
      selfStudy: [],
      skills: [],
      nameSkills: {
        Listening: 'Nghe', Speaking: 'Nói', Reading: 'Đọc', Writing: 'Viết', Grammar: 'Ngữ pháp', Vocabulary: 'Từ vựng',
      },
    };
  },
  created() {
    this.getTutorSelfStudyResult();
  },
  computed: {
    ...mapState('student_detail_bt', ['studentBlendedTutorDetail', 'filterForm']),
  },
  watch: {
    'filterForm.dateTime': {
      handler() {
        this.getTutorSelfStudyResult();
      },
      deep: true,
    },
  },
  methods: {
    async getTutorSelfStudyResult() {
      const result = await BlendedCareRepository.getTutorSelfStudyResult({
        lmsCoreUserId: this.studentBlendedTutorDetail.lms_core_user_id,
        startTime: this.filterForm.dateTime[0],
        endTime: this.filterForm.dateTime[1],
      });
      if (result.message === 'Success') {
        this.selfStudy = result.data.byCourseName;
        this.skills = result.data.bySkill;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.tutor-study-result-table {
  border-spacing: 0;
  width: 100%;
}
.tutor-study-result-table {
  display: block;
  border-spacing: 0;
  width: 100%;
  height: 250px;
  font-size: 12px;
  overflow: auto;
  thead {
    position: sticky;
    top: 0;
    z-index: 10;
    tr th {
      min-width: 80px;
      text-align: center;
      padding: 12px 16px;
      background: #4d4cac;
      color: #fff;
    }
  }
  tbody {
    tr {
      td {
        padding: 16px;
        text-align: center;
        border-bottom: 1px solid #fff;
        background: #f9f4f4;
        color: #000;
      }
    }
  }
}
@media screen and (max-width: 1440px) {
  .tutor-study-result-table {
    font-size: 12px;
    thead {
      tr th {
        padding: 8px 8px;
      }
    }
    tbody {
      tr {
        td {
          padding: 8px;
        }
      }
    }
  }
}
</style>
